export default {
  respondComment: 'Respond comment',
  commentResponseSubmittedSuccessfylly:
    'Comment response submitted successfully',
  changeCommentState: 'Change comment state',
  commentStateChangedSuccessfylly: 'Comment state changed successfully',
  draft: 'draft',
  saveAsDraft: 'save as draft',
  postPublishedSuccessfully: 'The post published successfylly',
  studyDurationMinute: 'study duration',
  likeCount: 'number of likes'
}
